import React from 'react';
import { InvoiceDTO } from '../domain/models';
import { CalculatorService } from '../services/CalculatorService';
import { formatMoney } from '../domain/models';

type Props = {
  invoice: Pick<InvoiceDTO, 'items'>;
};

const calc = new CalculatorService();

export function SummaryPanel({ invoice }: Props) {
  const totals = calc.totals(invoice.items);

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div>
        <h3 className="font-semibold mb-2">Zusammenfassung</h3>
        <ul className="text-sm space-y-1">
          <li className="flex justify-between"><span>Summe</span><span>{formatMoney(totals.grandTotal)}</span></li>
        </ul>
      </div>
    </div>
  );
}
